import { BUTTON_VARIANTS } from "@cdkglobal/radial";
import { useUIStateContext } from "../../../../contexts/UIStateContext";
import { StyledARMigrationDialog } from "../../../../utils/styled";
import { useIntl } from "react-intl";

export default function ARMigrationDialog(): JSX.Element {
  const {
    activeAccountsReceivableRecordMigrationInfo,
    setActiveAccountsReceivableRecordMigrationInfo,
    incrementConvertARScheduleTypeId,
  } = useUIStateContext();
  const { gridTableToast, isMigrationDialogOpen, newARScheduleCode } =
    activeAccountsReceivableRecordMigrationInfo;
  const intl = useIntl();

  const handleDialogClose = () => {
    setActiveAccountsReceivableRecordMigrationInfo({
      ...activeAccountsReceivableRecordMigrationInfo,
      isMigrationDialogOpen: false,
    });
  };

  const handleProceedClick = () => {
    setActiveAccountsReceivableRecordMigrationInfo({
      ...activeAccountsReceivableRecordMigrationInfo,
      isMigrationDialogOpen: false,
    });
    incrementConvertARScheduleTypeId();
  };

  if (gridTableToast.message.length === 0) {
    return (
      <StyledARMigrationDialog
        id="ar-migration-dialog"
        dataTestId="ar-migration-dialog"
        buttonsProps={[
          {
            id: "ar-migration-dialog-cancel",
            onClick: handleDialogClose,
            text: intl.formatMessage({
              id: "button.cancel",
              defaultMessage: "Cancel",
            }),
            variant: BUTTON_VARIANTS.TEXT,
          },
          {
            id: "ar-migration-dialog-proceed",
            onClick: handleProceedClick,
            text: intl.formatMessage({
              id: "button.proceed",
              defaultMessage: "Proceed",
            }),
            variant: BUTTON_VARIANTS.PRIMARY,
          },
        ]}
        isOpen={isMigrationDialogOpen}
        onClose={handleDialogClose}
        title={intl.formatMessage({
          id: "dialog.arMigrationTitleProceed",
          defaultMessage: "Confirm?",
        })}
      >
        Click proceed to migrate the Schedule Code Type, This process may take
        some time to complete.
        {newARScheduleCode && (
          <div>
            <strong>New Schedule Code:</strong> {newARScheduleCode}
          </div>
        )}
      </StyledARMigrationDialog>
    );
  }

  return (
    <StyledARMigrationDialog
      id="ar-migration-dialog"
      dataTestId="ar-migration-dialog"
      buttonsProps={[
        {
          id: "ar-migration-dialog-close",
          onClick: handleDialogClose,
          text: intl.formatMessage({
            id: "button.close",
            defaultMessage: "Close",
          }),
          variant: BUTTON_VARIANTS.TEXT,
        },
      ]}
      isOpen={isMigrationDialogOpen}
      onClose={handleDialogClose}
      title={intl.formatMessage({
        id: "dialog.arMigrationTitle",
        defaultMessage: "Action Restricted",
      })}
    >
      Creation & Editing is disabled for this setup because AR Schedule Code
      migration is active.
    </StyledARMigrationDialog>
  );
}
